module.exports = __webpack_public_path__ + "img/icon-transfer.ee082c9d.svg";